module.exports = __webpack_public_path__ + "static/media/robot-orange-broken.1d9fa424.svg";